export function parseUniverseList(universes = [], list = []) {
  if (!Array.isArray(universes)) {
    return list;
  }

  universes.forEach((universe) => {
    list.push(universe.name);
  });

  return list.sort();
}


export function parseUniverseListRecursive(universes = [], list = []) {
  if (!Array.isArray(universes)) {
    return list;
  }

  universes.forEach((universe) => {
    list.push(universe.name);

    if (universe.children.length) {
      return parseUniverseListRecursive(universe.children, list);
    }
  });

  return list.sort();
}
